import React, { useState, useEffect, FunctionComponent, Fragment, useRef } from "react"
import { IconContext } from "react-icons/lib"
import { TbUserScan } from "react-icons/tb"
import { IoMdMore } from "react-icons/io"
import { FaRegEdit } from "react-icons/fa"
import { HiOutlineTrash } from "react-icons/hi"
import { useModal } from "@murphy-frontend/web-core/contexts/ModalContext"
import { ModalConfiguration } from "@murphy-frontend/web-core/components/Modal"
import ResetConfirmationBody from "./ResetConfirmationBody"
import {useCustomer} from "../../../common/contexts/CustomerContext"

interface ActionsRowProps {
	userId: string
	onEditUser: (id: string) => void
	onDeleteUser: (id: string) => void
	userName: string
	customerUserId: string
	translations: Record<string, string>,
}

const ActionsRow: FunctionComponent<ActionsRowProps> = ({
	userId,
	onEditUser,
	onDeleteUser,
	userName,
	customerUserId,
	translations,
}) => {


	const {openModal, closeModal} = useModal()
	const [isOpen, setIsOpen] = useState(false)
	const {customer} = useCustomer()
	const dropDownRef = useRef(null)

	useEffect(() => {
		document.addEventListener("click", handleClickOutside)
		return () => document.removeEventListener("click", handleClickOutside)
	}, [])

	const handleClickInside = () => {
		setIsOpen(true)
	}

		function handleClickOutside(e: MouseEvent) {
		// e.preventDefault()
		if ((e.target as HTMLElement).classList.contains("useradmin-dropdown-content")) {
			return
		} else if (
			(e.target as HTMLElement).classList.contains("useradmin-select") ||
			!dropDownRef?.current.contains(e.target as HTMLElement)
		) {
			setIsOpen(false)
		}
	}



	const onClickResetMFA = () => {
		const modalConf: ModalConfiguration = {
			body: (
				<ResetConfirmationBody
					userName={userName}
					customerUserId={customerUserId}
					closeModal={closeModal}
					translations={translations}
				/>
			),
			hideButton: true,
			type: "warning",
			position: "center",
			hideCloseIcon: true
		}

		openModal(modalConf)
	}

	const dropDownClasses = isOpen
		? "useradmin-dropdown-content icon-hover-child useradmin-dropdown-content--active"
		: "useradmin-icon-hover useradmin-dropdown-content"

	return (
		<>
			<div className='useradmin-more-wrapper' onClick={handleClickInside} ref={dropDownRef}>
				<IconContext.Provider value={{ className: "btn-icon actions-more" }}>
					<IoMdMore />
				</IconContext.Provider>
				<div className={dropDownClasses}>
					<div className='useradmin-select' onClick={() => onEditUser(userId)}>
						<IconContext.Provider value={{ className: "btn-icon useradmin-more" }}>
							<FaRegEdit />
						</IconContext.Provider>
						{translations.updateUserProfile}
					</div>
					<div className='useradmin-select' onClick={() => onDeleteUser(userId)}>
						<IconContext.Provider value={{ className: "btn-icon useradmin-more" }}>
							<HiOutlineTrash />
						</IconContext.Provider>
						{translations.removeUser}
					</div>
					<div className='useradmin-select' onClick={() => onClickResetMFA()}>
						<IconContext.Provider value={{ className: "btn-icon useradmin-more" }}>
							<TbUserScan />
						</IconContext.Provider>
						{translations.restMfa}
					</div>
				</div>
			</div>
		</>
	)
}

export default ActionsRow
